import Vue from 'vue'
import AscClickOutside from './AscClickOutside'

Vue.directive('click-outside', AscClickOutside)
